<template>
  <div class="creation-demand-step-auto-book">
    <form @submit.prevent="save">
      <h2 class="step-title-optional">
        {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.DEMANDS.CREATION.@AUTO_BOOK_TITLE")) }}
      </h2>
      <section>
        <div class="q-pa-md">
          <div class="row q-col-gutter-md">
            <div class="col-12">
              <q-card
                :class="isAutoBookActivated ? 'auto-book-card' : 'auto-book-card__active'"
                class="cursor-pointer"
                @click="setAutoBookActivated(false)"
              >
                <q-card-section class="row items-center">
                  <QRadio v-model="isAutoBookActivated" :val="false" size="md" :color="isAutoBookActivated ? 'primary' : 'white'" />
                  <div class="text-h4">
                    {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.DEMANDS.CREATION.@AUTO_BOOK_MANUAL_SELECTION_LABEL")) }}
                  </div>
                </q-card-section>
                <q-card-section class="q-pt-none">
                  <q-item-section>
                    <q-item-label class="description-text">
                      <!-- eslint-disable-next-line vue/no-v-html -->
                      <p v-html="classicSelectionText"></p>
                    </q-item-label>
                  </q-item-section>
                </q-card-section>
              </q-card>
            </div>
            <div class="col-12">
              <q-card
                :class="isAutoBookActivated ? 'auto-book-card__active' : 'auto-book-card'"
                class="cursor-pointer"
                @click="setAutoBookActivated(true)"
              >
                <q-card-section class="row items-center">
                  <QRadio v-model="isAutoBookActivated" :val="true" size="md" :color="isAutoBookActivated ? 'white' : 'primary'" />
                  <div class="text-h4">
                    {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.DEMANDS.CREATION.@AUTO_BOOK_AUTOMATIC_SELECTION_LABEL")) }}
                  </div>
                </q-card-section>
                <q-card-section class="q-pt-none">
                  <q-item-section>
                    <q-item-label class="description-text">
                      <!-- eslint-disable-next-line vue/no-v-html -->
                      <p v-html="autoBookSelectionText"></p>
                    </q-item-label>
                  </q-item-section>
                </q-card-section>
              </q-card>
            </div>
          </div>
        </div>
      </section>
      <transition appear enter-active-class="animated fadeIn slower delay-1s" leave-active-class="animated fadeOut">
        <section class="q-footer q-layout__section--marginal fixed-bottom">
          <div>
            <QBtn
              color="secondary"
              class="full-width btn-navigation"
              :label="$t('ETAB.BUTTONS.@NEXT')"
              no-caps
              type="submit"
              :loading="loading"
              :disabled="submitting"
            />
          </div>
        </section>
      </transition>
    </form>
  </div>
</template>

<script>
  import { CreationStepAutoBookModel, ICreationStepAutoBook } from "@core/models";

  export default {
    props: {
      stepData: {
        type: Object,
        default: () => ({}),
      },
      loading: {
        type: Boolean,
        default: false,
      },
      stepAssets: {
        type: Object,
        default: () => ({}),
      },
    },
    emits: ["saveStep"],
    data() {
      return {
        submitting: false,
        isAutoBookActivated: undefined,
        autoBookSelectionText: undefined,
        classicSelectionText: undefined,
      };
    },
    computed: {
      stepDataModel() {
        return new CreationStepAutoBookModel(this.stepData);
      },
    },
    created() {
      this.isAutoBookActivated = this.stepDataModel.isAutoBookActivated();
      this.autoBookSelectionText = this.stepAssets.auto_book_selection_text;
      this.classicSelectionText = this.stepAssets.classic_selection_text;
    },
    methods: {
      setAutoBookActivated(value) {
        this.isAutoBookActivated = value;
      },
      save() {
        this.submitting = true;
        this.$emit("saveStep", { [ICreationStepAutoBook.active]: this.isAutoBookActivated });
        setTimeout(() => {
          this.submitting = false;
        }, 1000);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .creation-demand-step-auto-book {
    .auto-book-card {
      border-radius: $button-border-radius;
      transition: background-color 0.3s ease;
      box-shadow: $card-shadow;
      background-color: white;
      &__active {
        background-color: $primary;
        color: white;
      }
      &:hover {
        background-color: $primary-lighter;
      }
    }
    .description-text {
      > p {
        font-size: 14px;
        margin-bottom: 0;
      }
    }
  }
</style>
